module.exports = __webpack_public_path__ + "static/media/no-image.bb1fac8f.jpg";